import { render, staticRenderFns } from "./DialogProc.vue?vue&type=template&id=03945e31&scoped=true"
import script from "./DialogProc.vue?vue&type=script&lang=js"
export * from "./DialogProc.vue?vue&type=script&lang=js"
import style0 from "./DialogProc.vue?vue&type=style&index=0&id=03945e31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03945e31",
  null
  
)

export default component.exports